import Box from "@material-ui/core/Box";
import React from "react";

import theme from "@/theme";

const hasLink = { color: theme.palette.blue[500] } as React.CSSProperties;

// 診断結果の送信が連続で失敗した際に、通常のスナックバーに代えて表示する報告フォーム導線。
// src/utilities/NotifyNetworkError.tsx の NotifyNetworkError に渡す ErrorMessage として使う。
export const DiagnosisSubmitFailureMessage: React.FC = () => (
  <Box mt={-2}>
    診断結果の送信が繰り返し失敗しています。
    <ul>
      <li>インターネット接続をご確認ください。</li>
      <li>時間を置いて再度お試しください。</li>
    </ul>
    解決しない場合は
    <a href="https://form.run/@propally-1619963249" style={hasLink}>
      報告フォーム
    </a>
    にてご報告ください。
  </Box>
);
